export const isAuthenticated = (state) => {
  const token = state.auth?.auth?.idToken || state.auth?.auth?.tokenLogin;
  return !!(token || localStorage.getItem("tokenLogin"));
};
